import styled from 'styled-components';
import React from 'react';
import Typography from 'kingpin/atoms/Typography';
import Spinner from './Spinner';

export const BadgeDiv = styled.div<{
  borderColor: string;
  backgroundColor: string;
}>`
  display: inline-flex;
  max-width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 6px;
  height: 24px;

  background: ${(props) => props.backgroundColor};
  border-radius: 16px;
  border: 1px solid ${(props) => props.borderColor};
`;

export type BadgeType = 'Default' | 'Info' | 'Warning' | 'Danger' | 'Success';

const getBorderColor = (type: BadgeType) => {
  switch (type) {
    case 'Default':
      return 'var(--color-border-primary)';
    case 'Info':
      return 'var(--color-badge-info-border)';
    case 'Warning':
      return 'var(--color-badge-warning-border)';
    case 'Danger':
      return 'var(--color-badge-danger-border)';
    case 'Success':
      return 'var(--color-badge-success-border)';
  }
};

const getBackgroundColor = (type: BadgeType) => {
  switch (type) {
    case 'Default':
      return 'var(--color-bg-primary)';
    case 'Info':
      return 'var(--color-badge-info-bg)';
    case 'Warning':
      return 'var(--color-badge-warning-bg)';
    case 'Danger':
      return 'var(--color-badge-danger-bg)';
    case 'Success':
      return 'var(--color-badge-success-bg)';
  }
};

const Badge = ({
  isLoading,
  text,
  iconBefore,
  iconAfter,
  badgeType,
}: {
  isLoading?: boolean;
  text: string;
  height?: number;
  iconBefore?: JSX.Element;
  iconAfter?: JSX.Element;
  badgeType: 'Default' | 'Info' | 'Warning' | 'Danger' | 'Success';
}) => (
  <BadgeDiv
    data-testid={`${text}-badge`}
    borderColor={getBorderColor(badgeType)}
    backgroundColor={getBackgroundColor(badgeType)}
  >
    {isLoading && <Spinner color="#EE8C00" />}
    {iconBefore}
    <Typography.Body type="Badge" isEllipsis>
      {text}
    </Typography.Body>
    {iconAfter}
  </BadgeDiv>
);

export default Badge;
